<template>
  <dragPanel
    title="属性"
    :closePanel="closePanel"
    class="common-drag-panel">
    <div
      class="attributes-panel"
      v-if="attributeData.length">
      <div
        class="attr-type-box"
        v-if="elemType === 'entity'">
        <div>类型：</div>
        <div class="common-select-box">
          <el-select
            class="primary-select"
            size="small"
            :popper-append-to-body="false"
            :value="attrType"
            @change="handleAttrTypeChange">
            <el-option
              v-for="(item, index) in attrTypeList"
              :key="index"
              :label="item.paramsType"
              :value="item.paramsType">
            </el-option>
          </el-select>
        </div>
      </div>
      <el-scrollbar class="attributes-box">
        <el-collapse
          accordion
          :value="0"
          class="el-collapse-primary">
          <el-collapse-item
            :name="index"
            v-for="(item, index) in attributeData"
            :key="index">
            <template slot="title">
              <i class="el-icon-caret-right" />
              <span class="group-name-box">
                {{ item.group }}
              </span>
            </template>
            <div
              class="params-content-box"
              v-for="(val, i) in item.data"
              :key="i"
              :title="val.paramValue">
              <div class="name-box">{{ val.paramName }}</div>
              <div class="value-box">
                {{ ` ${val.paramValue}${val.paramType}` }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </div>
    <div
      v-else
      class="tips">
      <div v-if="elemType === 'entity'">当前构件没有属性信息</div>
      <div v-else>请选择一个构件，以查看对应属性</div>
    </div>
  </dragPanel>
</template>

<script>
import dragPanel from '@/components/CustomDragPanel.vue'

export default {
  data() {
    return {}
  },
  props: {
    attributeData: Array,
    elemType: String,
    attrType: String,
    attrTypeList: Array,
    updateElementAttr: Function,
    closePanel: Function
  },
  components: {
    dragPanel
  },
  methods: {
    handleAttrTypeChange(attrType) {
      this.updateElementAttr(attrType)
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 150px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);

  /deep/ .content {
    height: calc(100% - 45px);

    .attributes-panel {
      height: 100%;

      .attr-type-box {
        display: flex;
        align-items: center;
        padding: 5px 15px;
        line-height: 32px;
        font-size: 14px;

        .common-select-box {
          flex-grow: 1;
          text-align: left;

          .el-select {
            width: 100%;
          }
        }
      }

      .attributes-box {
        height: calc(100% - 50px);
        padding: 0 16px;

        .el-scrollbar__bar {
          display: none;
        }

        .el-collapse-item {
          &:last-child {
            border-bottom: 1px solid var(--attr-border-color);
          }
        }

        .el-scrollbar__wrap {
          // overflow-y: auto;
          overflow-x: hidden;
        }

        .group-name-box {
          margin-left: 2px;
          word-break: break-all;
          white-space: normal;
        }

        .params-content-box {
          display: grid;
          grid-template-columns: 1fr 2fr;
          text-align: left;
          background: transparent;
          border: 1px solid var(--attr-border-color);
          border-bottom: none;
          word-break: break-all;

          .name-box {
            padding: 4px 4px 4px 24px;
            color: var(--collapse-text-label-color);
            border-right: 1px solid var(--attr-border-color);
            display: flex;
            flex-wrap: wrap;
            align-items: center;
          }

          .value-box {
            padding: 4px 4px 4px 8px;
            color: var(--collapse-text-value-color);
            word-break: break-all;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
          }
        }
      }

      .el-collapse {
        .el-collapse-item__header {
          padding: 0px 15px;
          color: var(--default-color);
        }

        .el-collapse-item__wrap {
          background-color: transparent;
          border: none;
        }

        .el-collapse-item__content {
          padding-bottom: 0px;
        }
      }
    }

    .tips {
      font-size: 12px;
      margin-top: 36px;
      text-align: center;
      color: var(--base-bg-dark-color9);
    }
  }
}
</style>
